//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "activeApplySuc",
    components: {},
    data() {
        return {
            url: '',
            show: false,
            showBtn: false,
            time: 3,
            totalTime: 3,
            content: '3s跳转'
        };
    },
    methods: {
        onClicked() {
            // if (this.url.startsWith('http')) {
            //     const tempWindow = window.open('', '_blank', ''); //打开一个新的空白窗口
            //     // tempWindow.location.href = this.url;  //对新打开的页面进行重定向
            //
            // } else {
            //     let url = 'http://' + this.url;
            //     window.open(this.checkUrl(this.url), '_blank');
            // }
            this.$store.commit('activity/setIsJumpStatus', true)
            this.showBtn = true;
            // window.open(this.checkUrl(this.url), '_blank');
            window.open(this.checkUrl(this.url));
        },
        isEmpty(obj) {
            if (typeof obj == "undefined" || obj == null || obj === "") {
                return true;
            } else {
                return false;
            }
        },
        onCheckUrl() {
            // console.log(this.checkUrl(this.url))
            if (this.checkUrl(this.url)) {
                this.startCountDown();
            } else {
                this.showBtn = true;
            }
        },
        startCountDown() {
            // this.$refs.countDown.start();
            let clock = window.setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + 's跳转';
                if (this.totalTime === 0) {
                    window.clearInterval(clock);
                    this.totalTime = this.time;
                    this.content = this.totalTime + 's跳转';
                    if (!this.$store.state.activity.jumpStatus) {
                        this.onClicked()
                    }
                }
            }, 1000);
        },
        checkUrl(url) {
            if (url) {
                const blob = /^(blob)[^\s]+/
                const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
                if (!blob.test(url) && !reg.test(url)) {
                    return document.location.protocol + '//' + url
                }
            }
            return url
        }
    },
    created() {
        this.url = this.$store.state.activity.signUpJumpUrl;
        this.onCheckUrl()
    }
}
